package org.vreo.devicehub.features.vrmOutput.presentation.components

import kotlinx.serialization.json.Json
import devicehub.composeapp.generated.resources.Res
import org.vreo.devicehub.features.vrmOutput.domain.models.TimeZoneDisplay

/**
 * Timezone comparator to sort timezones by region and thane by city in alphabetical order
 */
private val timezoneComparator = compareBy<TimeZoneDisplay>(
    { it.region },
    { it.city }
)

/**
 * Get list of available time zones from the JSON file
 *
 * @param pathToJSON path to JSON file, e.g. /modules/timezones.json
 * @return list of time zone objects
 */
suspend fun getTimeZonesFromJson(pathToJSON: String): List<TimeZoneDisplay> {
    val bytes = Res.readBytes(pathToJSON)
    val jsonString = bytes.decodeToString()
    return Json
        .decodeFromString<List<TimeZoneDisplay>>(jsonString)
        .sortedWith(timezoneComparator)
}